<template>
  <div
    class="eui-slider-validator"
    v-show="display"
  >
    <!-- 遮罩层 -->
    <Transition
      name="eui-fade"
      @before-enter="beforeVisible"
      @after-leave="afterHide"
    >
      <div
        v-if="visible"
        @touchmove.prevent
        @click="maskClick()"
        class="eui-mask"
      />
    </Transition>
    <Transition
      name="eui-bounce"
    >
      <div
        v-if="visible"
        class="eui-slider-validator-imgContent"
      >
        <div class="eui-slider-validator-imgContent-textConTent fontsize-title-small">
          <p>请先进行安全验证</p>
          <p>拖动下方滑块完成拼图</p>
        </div>
        <div class="eui-slider-validator-imgContent-imgBox">
          <img
            :src="`data:image/png;base64,${bigImage}`"
            alt=""
            class="eui-slider-validator-imgContent-imgBox-bigImg"
          >
          <img
            ref="smallImage"
            :src="`data:image/png;base64,${smallImage}`"
            :style="{
              left: pressObj.moveLeft,
              top:`${yHeight/2}px`
            }"
            :class="[
              'eui-slider-validator-imgContent-imgBox-smallImg',
              {'eui-animation-shaking': shaking}
            ]"
          >
          <div
            class="eui-slider-validator-imgContent-imgBox-imgLoading"
            v-show="showLoading"
          >
            <div class="eui-animation-loading eui-slider-validator-icon eui-slider-validator-icon-loading" />
            <p>数据加载中…</p>
          </div>
          <div
            class="eui-slider-validator-imgContent-imgBox-showSuc"
            v-show="showSuccess"
          >
            <div class="eui-slider-validator-icon eui-slider-validator-icon-suc" />
            <p>只用了<em>{{ slideTimeSecond }}S</em>，超过了<em>{{ getOverNumber(slideTimeSecond) }}%</em>的用户</p>
          </div>
        </div>
        <div class="eui-slider-validator-imgContent-slideBox">
          <div class="eui-slider-validator-imgContent-slideBox-bgProcess">
            <p
              ref="activeProcess"
              class="eui-slider-validator-curBgProcess"
              :style="{width: pressObj.bgWidth}"
            />
          </div>
          <div
            ref="slideButton"
            :class="[
              'eui-slider-validator-icon',
              'eui-slider-validator-icon-slideBlock',
              {'eui-animation-shaking': shaking}
            ]"
            @mousedown="mousedown"
            :style="{left: pressObj.moveLeft}"
          />
        </div>
        <div class="eui-slider-validator-imgContent-bottomText">
          <p
            v-show="showErrorTip"
            class="showErrorTip"
          >
            {{ showErrorTip }}
          </p>
          <p
            @click="refreshImg($event)"
          >
            <i
              :class="[
                'eui-slider-validator-icon',
                'eui-slider-validator-icon-refresh',
                {roteRefresh}
              ]"
            />
            刷新
          </p>
        </div>
        <em
          class="eui-slider-validator-imgContent-closeDiv eui-slider-validator-icon eui-slider-validator-icon-close"
          @click="closeIconClick"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "EuiSliderValidator",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    bigImage: {
      type: String,
      default: "",
    },
    smallImage: {
      type: String,
      default: "",
    },
    yHeight: {
      type: Number,
      default: 0,
    },
    errorTipRefresh: {
      type: Boolean,
      default: true,
    },
    //是否禁用滑块
    sliderDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 后台图片类型，默认为 '2@img' 表示后台图片为 690 * 350 px 的两倍图，
     * 当传入的值为 '1@img' 表示后台图片为 345 * 175 px 的一倍图
     */
    imgSize: {
      type: String,
      default: "2@img",
    },
  },
  data () {
    return {
      display: this.visible,
      showSuccess: false,
      slideTimeSecond: 1,
      showLoading: false,
      showErrorTip: "",
      shaking: false,
      startLeftDistance: "0",
      pressObj: {
        bgWidth: this.startLeftDistance,
        moveLeft: this.startLeftDistance,
      },
      roteRefresh: false,
    };
  },
  watch: {
    visible (newValue) {
      // 监听到每次重新唤起，状态初始化
      if (newValue) {
        this.showSuccess = false;
        this.showLoading = false;
        this.pressObj = {
          bgWidth: this.startLeftDistance,
          moveLeft: this.startLeftDistance,
        };
      }
    },
  },
  computed: {
    /**
     * 根据服务端使用的是两倍图或一倍图，返回换算单位
     * javaImageWidth 表示服务端使用图片的宽度，用作计算滑动的绝对距离
     * heightPx2RemUnit 用作服务端返回的高度，换算 rem 的单位
     */
    calculateUnit () {
      const unitObj = {};
      if (this.imgSize === "2@img") {
        unitObj.javaImageWidth = 690;
        unitObj.heightPx2RemUnit = 75;
      } else if (this.imgSize === "1@img") {
        unitObj.javaImageWidth = 345;
        unitObj.heightPx2RemUnit = 37.5;
      }
      return unitObj;
    },
  },
  created () {
    this.animateEndStr = this.whichAnimationEvent();
    this.dealRequestAnimation();
  },
  methods: {
    mousedown (event) {
    	if(this.sliderDisabled) {
    		return ;
    	}
      this.touchstartTime = new Date();
      let moveLeft = "";
      const offsetLeft = event.target.parentNode.getBoundingClientRect().left;
      const slideWidth = event.target.offsetWidth; // 滑块的宽度
      const maxWidth = event.target.parentNode.offsetWidth - event.target.offsetWidth; // 可以滑动的最大长度
      const move = (moveEvent) => {
        const mouseX = moveEvent.clientX;
        moveLeft = mouseX - offsetLeft - slideWidth / 2;
        if (moveLeft <= parseInt(this.startLeftDistance, 10)) {
          moveLeft = this.startLeftDistance;
        }
        if (moveLeft >= maxWidth) {
          moveLeft = maxWidth;
        }
        this.pressObj.bgWidth = `${moveLeft + slideWidth / 2}px`;
        this.pressObj.moveLeft = `${moveLeft}px`;
      };
      const up = () => {
        this.touchEndTime = new Date();
        let slideTimeMs = this.touchEndTime.getTime() - this.touchstartTime.getTime();
        if (slideTimeMs < 100) {
        // 最低展示0.1s
          slideTimeMs = 100;
        }
        this.slideTimeSecond = (slideTimeMs / 1000).toFixed(1);
        const wrapperBox = Number(event.target.parentNode.offsetWidth);
        const sendPxCheck = (moveLeft / wrapperBox) * this.calculateUnit.javaImageWidth;
        this.$emit("slideEnd", sendPxCheck);
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", up);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);
    },
    fingerStart () {
      this.touchstartTime = new Date();
    },
    fingerMove (event) {
      const touch = event.changedTouches;
      if (touch && touch.length) {
        const { pageX } = touch[0];
        const maxWidth = touch[0].target.parentNode.offsetWidth - touch[0].target.offsetWidth; // 可以滑动的最大长度
        const offsetLeft = touch[0].target.parentNode.getBoundingClientRect().left;
        const slideWidth = touch[0].target.offsetWidth; // 滑块的宽度
        let moveLeft = pageX - offsetLeft - slideWidth / 2; // 滑块距离左边的距离
        if (moveLeft <= parseInt(this.startLeftDistance, 10)) {
          moveLeft = this.startLeftDistance;
        }
        if (moveLeft >= maxWidth) {
          moveLeft = maxWidth;
        }
        this.pressObj.bgWidth = `${moveLeft + slideWidth / 2}px`;
        this.pressObj.moveLeft = `${moveLeft}px`;
      }
    },
    fingerEnd (event) {
      this.touchEndTime = new Date();
      let slideTimeMs = this.touchEndTime.getTime() - this.touchstartTime.getTime();
      if (slideTimeMs < 100) {
        // 最低展示0.1s
        slideTimeMs = 100;
      }
      this.slideTimeSecond = (slideTimeMs / 1000).toFixed(1);
      if (event.changedTouches.length === 1) {
        const touch = event.changedTouches;
        const maxWidth = touch[0].target.parentNode.offsetWidth - touch[0].target.offsetWidth; // 可以滑动的最大长度
        const offsetLeft = touch[0].target.parentNode.getBoundingClientRect().left;
        const slideWidth = touch[0].target.offsetWidth; // 滑块的宽度
        let moveLeft = touch[0].pageX - offsetLeft - slideWidth / 2;
        if (moveLeft <= 0) { // 最左端边界处理
          moveLeft = 0;
        }
        if (moveLeft >= maxWidth) { // 最右端边界处理
          moveLeft = maxWidth;
        }
        const wrapperBox = Number(touch[0].target.parentNode.offsetWidth);
        const sendPxCheck = (moveLeft / wrapperBox) * this.calculateUnit.javaImageWidth;
        this.$emit("slideEnd", sendPxCheck);
      }
    },
    // 刷新图形验证码
    refreshImg (event) {
      if (event) {
        // 移除监听不能使用函数
        event.currentTarget.firstElementChild.removeEventListener(this.animateEndStr, this.closeRoteFlag);
        event.currentTarget.firstElementChild.addEventListener(this.animateEndStr, this.closeRoteFlag);
        this.roteRefresh = true;
      }
      this.showLoading = true;
      this.showSuccess = false;
      setTimeout(() => {
        this.showErrorTip = "";
      }, 2000);
      this.pressObj = {
        bgWidth: this.startLeftDistance,
        moveLeft: this.startLeftDistance,
      };
      this.$emit("refreshImg");
    },
    isPc () {
      const userAgentInfo = navigator.userAgent;
      const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    closeRoteFlag () {
      this.roteRefresh = false;
    },
    closeIconClick () {
      this.$emit("closeIconClick");
    },
    // 关闭当前loading
    closeLoading () {
      this.showLoading = false;
    },
    showLoadingFn () {
    	this.showLoading = true;
    },
    // 遮罩点击事件
    maskClick () {
      this.$emit("maskClick");
    },
    // 图形验证码展示成功
    success () {
      this.showSuccess = true;
      this.showLoading = false;
      this.showErrorTip = "";
    },
    // 滑块验证码报错提示方法
    errorTip (res) {
      // 滑块小图复原
      const { slideButton } = this.$refs;
      slideButton.removeEventListener(this.animateEndStr, this.backAndRefresh);
      slideButton.addEventListener(this.animateEndStr, this.backAndRefresh);
      this.shaking = true;
      this.showSuccess = false;
      this.showErrorTip = res;
    },
    // 滑块/小图片 运动回到起点,并且默认调用刷新
    backAndRefresh () {
      this.shaking = false;
      this.startMove(this.$refs.smallImage, { left: parseInt(this.startLeftDistance, 10) }, () => {
        if (this.errorTipRefresh) {
          this.refreshImg();
        }
      });
      this.startMove(this.$refs.slideButton, { left: parseInt(this.startLeftDistance, 10) });
      this.startMove(this.$refs.activeProcess, { width: parseInt(this.startLeftDistance, 10) });
    },
    beforeVisible () {
      this.display = true;
    },
    afterHide () {
      this.display = false;
    },
    // 根据用户滑动时间，计算超出百分比算法
    getOverNumber (slideTimeSecond) {
      if (!slideTimeSecond) {
        return "98";
      }
      let overNumber = "";
      if (slideTimeSecond > 0 && slideTimeSecond <= 0.7) {
        overNumber = 99 - this.slideTimeSecond * 10;
      }
      if (slideTimeSecond > 0.7 && slideTimeSecond <= 4) {
        overNumber = 106 - slideTimeSecond * 10;
      }
      if (slideTimeSecond > 4) {
        overNumber = 69 - parseInt(slideTimeSecond, 10);
      }
      if (overNumber <= 0) {
        overNumber = 1;
      }
      return overNumber;
    },
    // 元素运动方法
    startMove (element, changeData, func) {
      let iCurValue = 0;
      let iSpeed = 0;
      let bStop = false;
      const tempElement = element;
      window.cancelAnimationFrame(tempElement.timer);
      const moveFn = () => {
        bStop = true;
        // eslint-disable-next-line
        for (const keys in changeData) {
          if (keys) {
            if (keys === "opacity") {
              iCurValue = parseFloat(this.getStyle(tempElement, keys), 10) * 100;
            } else {
              iCurValue = parseInt(this.getStyle(tempElement, keys), 10);
            }
            iSpeed = (changeData[keys] - iCurValue) / 6;// 缓冲运动效果
            if (iSpeed > 0) {
              iSpeed = Math.ceil(iSpeed);
            } else {
              iSpeed = Math.floor(iSpeed);
            }
            if (keys === "opacity") {
              tempElement.style.opacity = (iCurValue + iSpeed) / 100;
            } else {
              tempElement.style[keys] = `${iCurValue + iSpeed}px`;
            }
            if (iCurValue !== changeData[keys]) {
              bStop = false;
            }
          }
        }
        if (bStop) {
          if (func) {
            func();// 当全部动作执行完毕之后, 执行回调函数.
          }
          window.cancelAnimationFrame(tempElement.timer);
        } else {
          tempElement.timer = window.requestAnimationFrame(moveFn);
        }
      };
      moveFn();
    },
    // 监听运动完毕兼容写法
    whichAnimationEvent () {
      let animationStr = "";
      const el = document.createElement("fakeelement");
      const animations = {
        animation: "animationend",
        OAnimation: "oAnimationEnd",
        MozAnimation: "animationend",
        WebkitAnimation: "webkitAnimationEnd",
      };
      // eslint-disable-next-line
      for (const t in animations) {
        if (el.style[t] !== undefined) {
          animationStr = animations[t];
          break;
        }
      }
      return animationStr;
    },
    // 高性能运动，兼容封装
    dealRequestAnimation () {
      let lastTime = 0;
      const vendors = ["ms", "moz", "webkit", "o"];
      for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[`${vendors[x]}RequestAnimationFrame`];
        window.cancelAnimationFrame = window[`${vendors[x]}CancelAnimationFrame`] || window[`${vendors[x]}CancelRequestAnimationFrame`];
      }
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = (callbackFn) => {
          const currTime = new Date().getTime();
          const timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
          const id = window.setTimeout(() => {
            callbackFn(currTime + timeToCall);
          }, timeToCall);
          lastTime = currTime + timeToCall;
          return id;
        };
      }
      if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = (id) => {
          clearTimeout(id);
        };
      }
    },
    // 获取元素当前属性
    getStyle (ele, name) {
      if (window.getComputedStyle) {
        return getComputedStyle(ele, null)[name];
      }
      return ele.getCurrentStyle[name];
    },
  },
};
</script>
<style scoped>
  @import "./slider-validator.css";
</style>



// WEBPACK FOOTER //
// src/oldCode/components/slider-validator/slider-validator.vue